import React, { createContext, useState, useContext, useEffect, useReducer, Suspense, lazy } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
// import {
//     Home,
//     Items,
//     UpdateItem,
//     AddItems,
//     CategorySection,
//     Addcategory,
//     UpdateCategory,
//     Order,
//     OrderDetail,
//     OrderHistory,
//     Employee,
//     AddMember,
//     UpdateStaff,
//     AdminDisplayCategory,
//     AddDisplayCat,
//     UpdateDisplayCate,
//     GiftCard,
//     AddCoupon,
//     UpdateCoupon,
//     Banner,
//     AddBanner,
//     UpdateBanner,
//     ManagePage,
//     AddModule,
//     UpdatePage,
//     AssignUrl,
//     Setting,
//     Cms,
//     UpdateCms,
//     Cart,
//     CartDetail,
//     Notifyme,
//     OrderPrint,
//     Publisher,
//     AddUpdatePublisher,
//     Dashboard,
//     Customer
// } from './index';

import ScrollToTop from "../Components/Admin/CommonComponents/ScrollToTop";
import { Login } from "../Components/Admin/Login/Login";
import { Authentication } from "../Components/Admin/Auth/Authentication";
import OrderPrint from "../Components/Admin/ScreenComponents/Order/OrderChild/OrdersPrint";
import { ChangePassParent } from "../Components/Admin/CommonComponents/ChangePass/ChangePassParent";
import { MergeComponents } from "../Components/Admin/CommonComponents/MergeComponents";

import AddBanner from "../Components/Admin/ScreenComponents/Banner/BannerChild/AddBanner";
import Banner from "../Components/Admin/ScreenComponents/Banner/BannerChild/Banner";
import UpdateBanner from "../Components/Admin/ScreenComponents/Banner/BannerChild/UpdateBanner";
import CartDetail from "../Components/Admin/ScreenComponents/Cart/CartChild/CartDetail";
import Cart from "../Components/Admin/ScreenComponents/Cart/CartChild/Cart";
import Addcategory from "../Components/Admin/ScreenComponents/Category/CategoryChild/Addcategory";
import CategorySection from "../Components/Admin/ScreenComponents/Category/CategoryChild/CategorySection";
import UpdateCategory from "../Components/Admin/ScreenComponents/Category/CategoryChild/UpdateCategory";
import Cms from "../Components/Admin/ScreenComponents/Cms/CmsChild/Cms";
import UpdateCms from "../Components/Admin/ScreenComponents/Cms/CmsChild/UpdateCms";
import Customer from "../Components/Admin/ScreenComponents/Customer/CustomerChild/Customer";
import AddDisplayCat from "../Components/Admin/ScreenComponents/DisplayCategory/DisplayCatChild/AddDisplayCate";
import AdminDisplayCategory from "../Components/Admin/ScreenComponents/DisplayCategory/DisplayCatChild/DisplayCategory";
import UpdateDisplayCate from "../Components/Admin/ScreenComponents/DisplayCategory/DisplayCatChild/UpdateDisplayCat";
import AddCoupon from "../Components/Admin/ScreenComponents/GiftCard/GiftCardChild/AddCoupon";
import GiftCard from "../Components/Admin/ScreenComponents/GiftCard/GiftCardChild/GiftCard";
import UpdateCoupon from "../Components/Admin/ScreenComponents/GiftCard/GiftCardChild/UpdateCoupon";
import AddItems from "../Components/Admin/ScreenComponents/Items/ItemsChild/AddItems";
import Items from "../Components/Admin/ScreenComponents/Items/ItemsChild/Items";
import UpdateItem from "../Components/Admin/ScreenComponents/Items/ItemsChild/UpdateItem";
import AddModule from "../Components/Admin/ScreenComponents/ManageStaffPage/ManagePageChild/AddModules";
import AssignUrl from "../Components/Admin/ScreenComponents/ManageStaffPage/ManagePageChild/AssignUrl";
import ManagePage from "../Components/Admin/ScreenComponents/ManageStaffPage/ManagePageChild/ManagePage";
import UpdatePage from "../Components/Admin/ScreenComponents/ManageStaffPage/ManagePageChild/UpdatePage";
import Notifyme from "../Components/Admin/ScreenComponents/Notifyme/NotifyMeChild/Notifyme";
import OrderDetail from "../Components/Admin/ScreenComponents/Order/OrderChild/OrderDetail";
import OrderHistory from "../Components/Admin/ScreenComponents/Order/OrderChild/OrderHistory";
import Order from "../Components/Admin/ScreenComponents/Order/OrderChild/Order";
import AddUpdatePublisher from "../Components/Admin/ScreenComponents/Publisher/PublisherChild/AddUpdatePublisher";
import Publisher from "../Components/Admin/ScreenComponents/Publisher/PublisherChild/Publisher";
import Setting from "../Components/Admin/ScreenComponents/Setting/SettingChild/Setting";
import UpdateStaff from "../Components/Admin/Login/Staff/UpdateStaff";
import AddMember from "../Components/Admin/Login/Staff/AddStaff";
import Employee from "../Components/Admin/Login/Staff/Employee";
import Dashboard from "../Components/Admin/ScreenComponents/Dashboard/DashboardChild/Dashboard";
import Courier from "../Components/Admin/ScreenComponents/Courier/Courier";
import UpdateCourier from "../Components/Admin/ScreenComponents/Courier/UpdateCourier";
import OtpController from "../Components/Admin/ScreenComponents/Otp/Otp";
// import InactivityHandler from "../Components/Admin/Login/AutoLogOut";
import Report from "../Components/Admin/ScreenComponents/Report/Report";
// import TrackingOrder from "../Components/User/ScreenComponents/TrackingOrder/TrackingOrder";
import ReorderList from "../Components/Admin/ScreenComponents/Sequence/Sequence";
import Vendor from "../Components/Admin/ScreenComponents/Vendor/Vendor";
import UpdateVendor from "../Components/Admin/ScreenComponents/Vendor/UpdateVendor";
// import InvoicePrint from "../Components/User/ScreenComponents/AccountSection/MyOrder/Myorderchild/InvoicePrint";

// import Home from "../Components/User/ScreenComponents/Home";
// import { SubCategoryItem } from "../Components/User/ScreenComponents/Home/SubCategoryItem";
// import { PageDetail } from "../Components/User/CommonComponents/PageDetail";
// import  AccountProfileParent from "../Components/User/ScreenComponents/AccountSection/Profile/ProfileParent/ProfileParent";
// import  MyorderParent from "../Components/User/ScreenComponents/AccountSection/MyOrder/MyorderParent/Myorderparent";
// import  AddaddressParent from "../Components/User/ScreenComponents/AccountSection/AddAddress/AddadressParent/AddaddressParent";
// import  OrderDetailParent from "../Components/User/ScreenComponents/AccountSection/OrderDetail/OrderDetailParent/OrderDetailParent";
// import  AddressDetailParent from "../Components/User/ScreenComponents/AccountSection/AddresDetail/AddressDetailParent/AddressDetailParent";
// import  ChangePasswordParent from "../Components/User/ScreenComponents/AccountSection/ChangePassword/ChangePasswordParent/ChangePasswordParent";
// import  Loading from "../Components/User/CommonComponents/Loading";
// import  AdressForm from "../Components/User/CommonComponents/Cart/AdressForm";
// import  SearchDetail from "../Components/User/CommonComponents/SearchDetail";

// import AboutUs from "../Components/User/CommonComponents/Footer-Sections/AboutUs";
// import PrivacyPolicy from "../Components/User/CommonComponents/Footer-Sections/PrivacyPolicy";
// import ContactUs from "../Components/User/CommonComponents/Footer-Sections/ContactUs";
// import TermsConditions from "../Components/User/CommonComponents/Footer-Sections/TermsConditions";
// import TrackOrder from "../Components/User/CommonComponents/Footer-Sections/TrackOrder";
// import RefundPolicy from "../Components/User/CommonComponents/Footer-Sections/RefundPolicy";
// import ShippingPolicy from "../Components/User/CommonComponents/Footer-Sections/ShippingPolicy";
// import CancellationPolicy from "../Components/User/CommonComponents/Footer-Sections/CancellationPolicy";
// import ReturnReplacement from "../Components/User/CommonComponents/Footer-Sections/ReturnReplacement";

const Home = lazy(() => import('../Components/User/ScreenComponents/Home'))
const SubCategoryItem = lazy(() => import('../Components/User/ScreenComponents/Home/SubCategoryItem'))
const PageDetail = lazy(() => import('../Components/User/CommonComponents/PageDetail'))
const AboutUs = lazy(() => import('../Components/User/CommonComponents/Footer-Sections/AboutUs'))
const PrivacyPolicy = lazy(() => import('../Components/User/CommonComponents/Footer-Sections/PrivacyPolicy'))
const ContactUs = lazy(() => import('../Components/User/CommonComponents/Footer-Sections/ContactUs'))
const TermsConditions = lazy(() => import('../Components/User/CommonComponents/Footer-Sections/TermsConditions'))
const TrackOrder = lazy(() => import('../Components/User/CommonComponents/Footer-Sections/TrackOrder'))
const RefundPolicy = lazy(() => import('../Components/User/CommonComponents/Footer-Sections/RefundPolicy'))
const ShippingPolicy = lazy(() => import('../Components/User/CommonComponents/Footer-Sections/ShippingPolicy'))
const CancellationPolicy = lazy(() => import('../Components/User/CommonComponents/Footer-Sections/CancellationPolicy'))
const ReturnReplacement = lazy(() => import('../Components/User/CommonComponents/Footer-Sections/ReturnReplacement'))

const AccountProfileParent = lazy(() => import('../Components/User/ScreenComponents/AccountSection/Profile/ProfileParent/ProfileParent'))
const MyorderParent = lazy(() => import('../Components/User/ScreenComponents/AccountSection/MyOrder/MyorderParent/Myorderparent'))
const AddaddressParent = lazy(() => import('../Components/User/ScreenComponents/AccountSection/AddAddress/AddadressParent/AddaddressParent'))
const OrderDetailParent = lazy(() => import('../Components/User/ScreenComponents/AccountSection/OrderDetail/OrderDetailParent/OrderDetailParent'))
const AddressDetailParent = lazy(() => import('../Components/User/ScreenComponents/AccountSection/AddresDetail/AddressDetailParent/AddressDetailParent'))
const Loading = lazy(() => import('../Components/User/CommonComponents/Loading'))
const AdressForm = lazy(() => import('../Components/User/CommonComponents/Cart/AdressForm'))
const SearchDetail = lazy(() => import('../Components/User/CommonComponents/SearchDetail'))

const RoleContext = createContext();
export const useRole = () => useContext(RoleContext);

function Routing() {

    const BASE_URL = process.env.REACT_APP_PP_URL;
    const token = sessionStorage.getItem('tokenKey');

    const [access, setAccess] = useState();
    const [userPermissions, setUserPermission] = useState([]);

    const location = useLocation();
    const isAdminRoute = location.pathname.includes("/admin");
    const [loading, setLoading] = useState(isAdminRoute ? true : false);

    const getUrls = async () => {
        setLoading(true);
        try {
            const res = await fetch(`${BASE_URL}/ops/v1/common-user/get-assign-urls`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setAccess(getRes);
                setUserPermission(getRes?.responsePacket?.map(itm => itm.url));
            };
        } catch (e) {
            console.log(e, 'error in get url api');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (token) {
            getUrls();
        } else if (!isAdminRoute) {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    }, []);


    const utilityReducer = (state, action) => {
        switch (action.type) {
            case "SET_USER_CART":
                localStorage.setItem("userCart", JSON.stringify(action.payload));
                return {
                    ...state,
                    userCart: action.payload,
                };
            case "CLEAR_USER_CART":
                localStorage.removeItem("userCart");
                return {
                    ...state,
                    userCart: null,
                };
            default:
                return state;
        }
    };
    const initialCart = localStorage.getItem("userCart")
        ? JSON.parse(localStorage.getItem("userCart"))
        : [];
    const [utilityStates, dispatchUtility] = useReducer(utilityReducer, { userCart: initialCart });

    const routesPages = [
        { path: 'item', component: Items, module: 'item', },
        { path: 'UpdateItem/:id', component: UpdateItem, module: 'item', },
        { path: 'additemparent', component: AddItems, module: 'item', url: 'admin/v1/item/save' },
        { path: 'category', component: CategorySection, module: 'category', },
        { path: 'sequence', component: ReorderList, module: 'category', },
        { path: 'addcategory', component: Addcategory, module: 'category', url: 'admin/v1/category/save' },
        { path: 'Updatecategory/:id', component: UpdateCategory, module: 'category', },
        { path: 'order', component: Order, module: 'order', },
        { path: 'orderDetail', component: OrderDetail, module: 'order', },
        { path: 'orderHistory', component: OrderHistory, module: 'order', },
        { path: 'staff', component: Employee, module: 'staff', },
        { path: 'member', component: AddMember, module: 'staff', url: 'admin/v1/staff/save' },
        { path: 'updateStaff/:id', component: UpdateStaff, module: 'staff', },
        { path: 'displayCat', component: AdminDisplayCategory, module: "display_category" },
        { path: 'addDisplayCat', component: AddDisplayCat, module: "display_category", url: 'admin/v1/display-category/save' },
        { path: 'updateDisplay/:id', component: UpdateDisplayCate, module: "display_category" },
        { path: 'gift', component: GiftCard, module: 'coupon', },
        { path: 'addGift', component: AddCoupon, module: 'coupon', url: 'admin/v1/couponCode/save' },
        { path: 'updateCoupon/:id', component: UpdateCoupon, module: 'coupon' },
        { path: 'banner', component: Banner, module: 'banner', },
        { path: 'addBanner', component: AddBanner, module: 'banner', url: 'admin/v1/banner/create' },
        { path: 'updateBanner/:id', component: UpdateBanner, module: 'banner', },
        // { path: 'otherField', component: OtherFieldParent, module: 'other_fields', },
        // { path: 'addField', component: AddFieldParent, module: 'other_fields', },
        // { path: 'updateField', component: UpdateFieldParent, module: 'other_fields', },
        { path: 'managePage', component: ManagePage, module: 'manage_pages', },
        { path: 'addmanage', component: AddModule, module: 'manage_pages', url: 'admin/v1/module/save' },
        { path: 'updateModal/:id', component: UpdatePage, module: 'manage_pages', },
        { path: 'assignUrl', component: AssignUrl, module: 'staff', url: "admin/v1/staff/assign-url" },
        { path: 'setting', component: Setting, module: 'setting', },
        { path: 'cms', component: Cms, module: 'cms' },
        { path: 'updateCms', component: UpdateCms, module: 'cms', url: "admin/v1/website-cms" },
        { path: 'cart', component: Cart, module: 'cart' },
        { path: 'cartDetail', component: CartDetail, module: 'cart' },
        { path: 'customer', component: Customer, module: 'customer' },
        { path: 'notify', component: Notifyme, module: 'notify_me_items' },
        { path: 'print', component: OrderPrint, module: "order" },
        { path: "publisher", component: Publisher, module: "publisher" },
        { path: "vendor", component: Vendor, module: "publisher" },
        { path: "vendorUpdate", component: UpdateVendor, module: "publisher" },
        { path: "addPublisher", component: AddUpdatePublisher, module: "publisher" },
        { path: "courier", component: Courier, module: "courier" },
        { path: "modifyCourier", component: UpdateCourier, module: "courier", url: "admin/v1/courier/save" },
        { path: "otps", component: OtpController, module: "order" },
        { path: "report", component: Report, module: "report" },
    ];

    const AUTO_LOGOUT_TIME = 30 * 60 * 1000;
    const navigate = useNavigate();

    useEffect(() => {
        let logoutTimer;
        const resetTimer = () => {
            const tokenn = sessionStorage.getItem('tokenKey');
            clearTimeout(logoutTimer);
            if (tokenn) {
                logoutTimer = setTimeout(() => {
                    sessionStorage.removeItem("tokenKey");
                    navigate("/login");
                }, AUTO_LOGOUT_TIME);
            }
        };

        const activityEvents = ["mousemove", "keydown", "click", "scroll"];

        activityEvents.forEach((event) => {
            window.addEventListener(event, resetTimer);
        });

        resetTimer();
        return () => {
            clearTimeout(logoutTimer);
            activityEvents.forEach((event) => {
                window.removeEventListener(event, resetTimer);
            });
        };
    }, [navigate]);

    return (
        <>
            <RoleContext.Provider value={{ access, userPermissions, utilityStates, dispatchUtility }}>
                <ScrollToTop />
                <Suspense>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/admin" element={<Authentication />}>

                            <Route path="dash" element={<MergeComponents getComponent={<Dashboard />} />} />
                            <Route path="changePass" element={<ChangePassParent />} />
                            {
                                routesPages.map((itm) => {
                                    if (!itm.url || userPermissions?.includes(itm.url)) {
                                        return (
                                            access?.responsePacket?.some((item) => item.moduleDetail?.parentTitle === itm.module) &&
                                            <Route key={itm.path} path={itm.path} element={<MergeComponents getComponent={<itm.component />} />} />
                                        );
                                    }
                                })
                            }

                        </Route>

                        <Route path="/" element={<Home />} />

                        {/* <Route path='/subcategoryItem/:id' element={<SubCategoryItem />} /> */}
                        <Route path="/category/:slug" element={<SubCategoryItem />} />
                        {/* <Route path="/pagedetail/:id" element={<PageDetail />} /> */}
                        <Route path="/book/:slug" element={<PageDetail />} />
                        <Route path="*" element={
                            loading ?
                                <div className="loading-container" style={{ height: "100vh" }}>
                                    <div className="spinner"></div>
                                    <p>Loading...</p>
                                </div> :
                                <div>page not found</div>} />

                        <Route path="/accountparentprofile" element={<AccountProfileParent />} />

                        <Route path="/accountparentmyorder" element={<MyorderParent />} />

                        <Route path="/accountparentaddaddress" element={<AddaddressParent />} />

                        <Route path="/accountparentoderdetail" element={<OrderDetailParent />} />

                        <Route path="/accountparentmyorder" element={<MyorderParent />} />

                        <Route path="/accountparentaddaddress" element={<AddaddressParent />} />

                        <Route path="/accountparentoderdetail" element={<OrderDetailParent />} />

                        <Route path="/accountparentaddressdetail" element={<AddressDetailParent />} />

                        <Route path="/loading" element={<Loading />} />

                        <Route path="/addaddres" element={<AdressForm />} />

                        <Route path="/searchdetail" element={<SearchDetail />} />

                        <Route path="/pages">

                            <Route path="about-us" element={<AboutUs />} />

                            <Route path="privacy-policy" element={<PrivacyPolicy />} />

                            <Route path="contact" element={<ContactUs />} />

                            <Route path="terms-conditions" element={<TermsConditions />} />

                            <Route path="trackOrder" element={<TrackOrder />} />

                            <Route path="refund-policy" element={<RefundPolicy />} />

                            <Route path="Shipping-Policy" element={<ShippingPolicy />} />

                            <Route path="Cancellation-Policy" element={<CancellationPolicy />} />

                            <Route path="return-replacement" element={<ReturnReplacement />} />

                        </Route>

                    </Routes>
                </Suspense>
            </RoleContext.Provider>
        </>
    );
};

export { Routing }